import { ReactElement } from 'react';
import { TPartnersCardProps } from './PartnersCard.types';
import Link from 'next/link';
import * as S from './PartnersCard.style';
import URL from '@/common/app/utils/urlsUtils';

const PartnersCard = (partners: TPartnersCardProps): ReactElement => {
    return (
        <Link href={(partners.url || partners.slug).toLowerCase()} passHref>
            <S.CardContainer>
                <S.ImgWrap>
                    <S.Gradient />
                    <S.Image
                        src={`${URL.image}/activity/${partners.activity?.id}/700x600/${partners.activity?.slug}.jpg`}
                        alt="partner-image"
                        width="700"
                        height="600"
                        loading="lazy"
                        decoding="async"
                    />
                </S.ImgWrap>
                <S.Content>
                    <S.Title>{partners.title}</S.Title>
                    <S.BottomLeft className="activity-count">
                        {partners.count_activities}{' '}
                        {parseInt(partners.count_activities) > 1 ? 'Activities' : 'Activity'}
                    </S.BottomLeft>
                </S.Content>
            </S.CardContainer>
        </Link>
    );
};

export { PartnersCard };
export default PartnersCard;
